<template>
<header id='navigation_header' class='top-navigation-container'>
    <div class='header-bar'>
        <div class='header-container'>
            <div class='nav-bar-items'>
                <div class='mobile-menu-container'>
                    <MobileMenu :menu_items='menu_items' :headings='headings' :sub_headings='sub_headings'/>
                </div>
                <div class='left-col'>
                    <Logo/>
                    <DesktopMenuBar :menu_items='menu_items' :headings='headings' :sub_headings='sub_headings'/>
                </div>
                
                <div class='right-container'>
                    <Button text='Book a Demo' theme='purple' id='header-book-demo-button' @click='bookADemo'/>
                </div>

            </div>
        </div>
       
    </div>
    <PrerenderedMenu :headings='headings'/>
    
</header>
</template>

<script>
import DesktopMenuBar from '@/ecom/components/navigation/header/menus/DesktopMenuBar.vue';
import Logo from '@/ecom/components/navigation/header/Logo.vue';
import MobileMenu from '@/ecom/components/navigation/header/menus/MobileMenu.vue';
import PrerenderedMenu from '@/ecom/components/navigation/header/menus/PrerenderedMenu.vue';
import Button from '@/ecom/components/buttons/Button.vue';
import {checkAuth} from "@/global/modules/functions.js";

export default {
    components: {DesktopMenuBar, Logo, MobileMenu, PrerenderedMenu, Button},
    props: ['updated_cart_watcher'],
        data(){
            return{
                menu_items:[],
                headings: [],
                sub_headings:[],
                items: [],
            }
        },
    methods:{
        async getMenuItems(){
            let response = await fetch(`/api/nav-bar/menu-items`, {
                method: 'GET',
                credentials: 'include'
            });

            let results = await checkAuth(response);
            
            if (response.status === 200){
                this.menu_items = results.menu_items;
                this.formatMenuData();
            }
        },
        formatMenuData(){
            this.headings = this.menu_items.filter(x=>x.parent_id == 0);

            for (let i = 0; i < this.headings.length; i++) {
                let sub_headings = this.menu_items.filter(x=>x.parent_id == this.headings[i].id);
                this.headings[i].sub_headings = sub_headings;

                for (let j = 0; j < this.headings[i].sub_headings.length; j++) {
                    let items = this.menu_items.filter(x=>x.parent_id == this.headings[i].sub_headings[j].id);
                    this.headings[i].sub_headings[j].menu_items = items;
                }
            }
        },
        bookADemo(){
            this.$router.push('/contact');
        }
    },
    created(){
        this.getMenuItems();
        window.addEventListener('scroll', () => {
            const header = document.querySelector('header');
            header.classList.toggle('scrolled', window.scrollY > 50);
        });
    }
}
</script>

<style lang="scss" scoped>

.top-navigation-container{
    position: fixed; 
    width: 100%; 
    z-index: 99;
    top: 0;
    left: 0;
    right: 0;
    z-index: 100;

  /* Default: transparent, sits over hero */
    background: transparent;
    transition: background 0.3s ease, backdrop-filter 0.3s ease;
    height: var(--top-nav-bar-height);
    backdrop-filter: blur(10px);
    -webkit-backdrop-filter: blur(10px);
    padding: 24px;
    box-sizing: border-box;

    @media(max-width: 768px){
        background: #040711;
    }

}

.top-navigation-container.scrolled{
//       background: rgba(0, 0, 0, 0.75);
//   backdrop-filter: blur(10px);
//   -webkit-backdrop-filter: blur(10px);
}



.header-bar {
// 	 background: rgba(0, 0, 0, 0.75);
//   backdrop-filter: blur(10px);
//   -webkit-backdrop-filter: blur(10px); /* Safari */

	// background-color: white;
	color: var(--top-nav-bar-text-colour);
    align-content: center;
    padding-left: 20px;

    @media(max-width: 768px){
        padding-left: 0px;
    }
    // padding-right: 20px;
}

.left-col{
    display: flex;
    gap: 24px;
    align-items: center;
}

.header-container{
    margin: auto;
    max-width: 1600px;
    
}

.nav-bar-items{
    color: black;
    display: flex;
    justify-content: space-between;
    font-size: 0.95rem;
    padding-left: 20px;
    padding-right: 20px;
    align-items: center;
}

.right-container{
    display: flex;
    gap: 22px;
    align-items: center;
    justify-content: flex-end;

    @media(max-width: 768px){
        gap: 20px;
        flex-grow: 1;
    }
}

.mobile-menu-container{
    display: none;

    @media(max-width: 768px){
        display: block;
        margin-right: 10px;
    }
}
</style>